import axios from 'axios';
import useToken from '../App/useToken';

class courseService {
  getCourseByName(course_name, token) {
    return new Promise(async (resolve, reject) => {
      await fetch(`${process.env.REACT_APP_BACKEND_URL}api/v1/courses/${course_name}`, {
        method: 'GET',
        headers: {
          'token': token
        },
      })
        .then(data => resolve(data.json()))
        .catch(err => reject(err))
    })
  }

  deleteCourseByName(course_name, token) {
    return new Promise(async (resolve, reject) => {
      await fetch(`${process.env.REACT_APP_BACKEND_URL}api/v1/courses/${course_name}`, {
        method: 'DELETE',
        headers: {
          'token': token
        },
      })
        .then(data => resolve(data.json()))
        .catch(err => reject(err))
    })
  }

  getCourseByMajorName(major_name, token) {
    return new Promise(async (resolve, reject) => {
      await fetch(`${process.env.REACT_APP_BACKEND_URL}api/v1/majorCourses/${major_name}`, {
        method: 'GET',
        headers: {
          'token': token
        },
      })
        .then(data => resolve(data.json()))
        .catch(err => reject(err))
    })
  }

  getInfoByMajorCourseName(major_name, token) {
    return new Promise(async (resolve, reject) => {
      await fetch(`${process.env.REACT_APP_BACKEND_URL}api/v1/majorCourses/${major_name}/info`, {
        method: 'GET',
        headers: {
          'token': token,
          'Content-Type': 'application/json'
        }
      })
        .then(data => resolve(data.json()))
        .catch(err => reject(err))
    })
  }

  createCourse(data, token, isSpcApprove) {
    return new Promise(async (resolve, reject) => {
      const request = new FormData() 
      request.append('majorCourse', data.majorCourseId)
      request.append('enabled', data.enabled)
      request.append('name', data.name)
      request.append('description', data.description)
      request.append('amount', data.amount)
      request.append('majorCourseName', data.majorCourseName)
      request.append('yearOfCourse', data.yearOfCourse)
      request.append('terms', JSON.stringify(data.terms))
      request.append('stardTermPeriodUnit', data.stardTermPeriodUnit)
      request.append('endTermPeriodUnit', data.endTermPeriodUnit)
      if (isSpcApprove) {
        request.append('stardTermPeriodSpc', data.stardTermPeriodSpc)
        request.append('endTermPeriodSpc', data.endTermPeriodSpc)
      }
      request.append('qualifications', JSON.stringify(data.qualifications))
      request.append('file', data.file)
      axios.post(`${process.env.REACT_APP_BACKEND_URL}api/v1/courses`, request, { headers: { 'token': token } })
        .then(res => { resolve(res)})
        .catch(err => { reject(err.response.data)})
    })
  }

  editCourse(data, token, isSpcApprove) {
    return new Promise(async (resolve, reject) => {
      console.log('data :>> ', data);
      const request = new FormData() 
      request.append('majorCourse', data.majorCourseId)
      request.append('enabled', data.enabled)
      request.append('name', data.name)
      request.append('description', data.description)
      request.append('amount', data.amount)
      request.append('majorCourseName', data.majorCourseName)
      request.append('yearOfCourse', data.yearOfCourse)
      request.append('terms', JSON.stringify(data.terms))
      request.append('stardTermPeriodUnit', data.stardTermPeriodUnit)
      request.append('endTermPeriodUnit', data.endTermPeriodUnit)
      if (isSpcApprove) {
        request.append('stardTermPeriodSpc', data.stardTermPeriodSpc)
        request.append('endTermPeriodSpc', data.endTermPeriodSpc)
      }
      request.append('qualifications', JSON.stringify(data.qualifications))
      // request.append('file', data.file)
      axios.patch(`${process.env.REACT_APP_BACKEND_URL}api/v1/courses/${data.courseId}`, request, { headers: { 'token': token } })
        .then(res => { resolve(res)})
        .catch(err => { reject(err.response.data)})
    })
  }

  checkStudentQualification(course_name, airforce_id, token) {
    return new Promise(async (resolve, reject) => {
      await fetch(`${process.env.REACT_APP_BACKEND_URL}api/v1/courses/${course_name}/user/${airforce_id}/qualification`, {
        method: 'GET',
        headers: {
          'token': token
        },
      })
        .then(data => resolve(data.json()))
        .catch(err => reject(err))
    })
  }
  
  dowloadFile(dir, name) {
    return new Promise(async (resolve, reject) => {
      resolve(`${process.env.REACT_APP_BACKEND_URL}api/v1/users/files/download/${dir}/${name}`)
    })
  }

  clearStudentCourse(courseId, token) {
    return new Promise(async (resolve, reject) => {
      await fetch(`${process.env.REACT_APP_BACKEND_URL}api/v1/courses/${courseId}/clearStudentCourse`, {
        method: 'PATCH',
        headers: {
          'token': token
        },
      })
        .then(data => resolve(data.json()))
        .catch(err => reject(err))
    })
  }

}

  export default courseService;